<template>
  <div class="EditNote" @click.stop="">
    <van-nav-bar
      class="nav"
      title="笔记"
      left-text="取消"
      right-text="完成"
      @click-left="data.show=false"
      @click-right="ok"
    />
    <div class="scroll-nav">
      <div class="layout-row head">
        <img src="" alt="" />
        <div class="font-14-333">我</div>
      </div>
      <textarea
        name=""
        id=""
        cols="30"
        rows="10"
        placeholder="写笔记"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
    props:['data'],
    data() {
        return {
            
        }
    },
};
</script>

<style lang="scss" scoped>
.EditNote {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.scroll-nav {
  height: calc(100% - 46px);
  overflow-y: auto;
}
.head {
  align-items: center;
  padding: 0.75rem 0.75rem 0.5rem 0.75rem;
  img {
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    margin-right: 0.4rem;
  }
}

textarea {
  width: calc(100% - 1.5rem);
  margin: 0 0.75rem;
  background: #f6f6f6;
  height: 4.5rem;
  padding: 0.75rem 0.55rem;
  box-sizing: border-box;
  border: none;
  font-size: 0.7rem;
}

textarea::-webkit-input-placeholder {
  font-size: 0.7rem;
  color: #999999;
}
</style>


// WEBPACK FOOTER //
// src/page/comment/EditNote.vue